<v-alert v-model="showAlert" :title="'contract.view.add_service.confirmation'" :text="alertText" :successButtonText="$t('contract.view.add_service.confirm')" :cancelButtonText="$t('clients.view.cancel')" @success="save" @cancel="showAlert = false"></v-alert>

<div class="add_service_wrapper">
    <div class="add_service_body" v-click-outside="clickOutside">
        <div class="add_service_title">{{$t('contract.view.add_service.add_service')}}</div>
        <div class="add_service">
            <v-select class="mt-4 mb-4" v-model="selectedService" :label="'contract.view.add_service.service'" :items="services" @update:modelValue="selectService" :errorText="serviceErrorText" @click="serviceErrorText = ''"></v-select>
            <p class="mt-0 mb-2">{{$t('contract.view.add_service.price')}}: <span class="price_span">{{selectedPrice}}</span></p>
            <p class="mt-0 mb-2">{{$t('contract.view.add_service.first_payment')}}: <span class="price_span">{{selectedFirstPaymentAmount}}</span></p>

            <h4 class="mt-3 mb-2">{{$t('add_entity_payment_method.payment_method')}}</h4>

            <v-radio class="ml-2" v-model="selectedMethod" :radioList="availableMethod" :mb="2"></v-radio>
        </div>
        <div class="add_service_buttons_wrapper">
            <button class="primary_button" @click="clickOnSaveButton" :disabled="isButtonDisabled">{{$t('contract.view.add_service.add') }}</button>
            <button class="secondary_button button_space" @click="$emit('close')">{{$t('contract.view.add_service.cancel')}}</button>
        </div>
    </div>
</div>

